import React from 'react';
import config from '../../config';
export default function Footer({ isEmpty }) {
  console.log('is empty', isEmpty);

  if (isEmpty) {
    return (
      <section id="footer" className="empty">
        {/* <div className="inner"></div> */}
      </section>
    )
  }

  return (
    <section id="footer">
      <div className="inner">
        <h2 className="major">Get in touch</h2>
        <form method="post" netlify-honeypot="bot-field" data-netlify="true">
          <input type="hidden" name="bot-field" />
          <div className="fields">
            <div className="field">
              <label htmlFor="name">Name</label>
              <input type="text" name="name" id="name" />
            </div>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input type="email" name="email" id="email" />
            </div>
            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea name="message" id="message" rows="4"></textarea>
            </div>
          </div>
          <ul className="actions">
            <li>
              <input type="submit" value="Send Message" />
            </li>
          </ul>
        </form>
        <ul className="contact">
          {config.socialLinks.map(social => {
            const { icon, url, display } = social;
            return (
              <li className={`${icon}`} key={url}>
                <a href={url}>{display || url}</a>
              </li>
            );
          })}
        </ul>
        <ul className="copyright">
          <li>&copy; Solid State. All rights reserved.</li>
          <li>
            Design: <a href="http://html5up.net">HTML5 UP</a>
          </li>
        </ul>
      </div>
    </section>
  );
}
